import { render, staticRenderFns } from "./ContestNolaNovelSelectItem.vue?vue&type=template&id=df1675b4&scoped=true"
import script from "./ContestNolaNovelSelectItem.vue?vue&type=script&lang=ts"
export * from "./ContestNolaNovelSelectItem.vue?vue&type=script&lang=ts"
import style0 from "./ContestNolaNovelSelectItem.vue?vue&type=style&index=0&id=df1675b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1675b4",
  null
  
)

export default component.exports